import './vendor';
import './helpers';
import './components/social';
import './components/analytics';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import './popup';
import video from './components/video';
import header from './components/header';
import footer from './components/footer';
import scrollToAnchor from './modules/scrollToAnchor';
import lazyLoading from './modules/lazyLoading';
// import scroller from './components/scroller';
import slider from './components/slider';
import preloader from './components/preloader';
import lottie from "./components/lottie";
import {aosInit} from "./components/aos";

ieFix();
vhFix();
actualYear();
lazyLoading.init();
scrollToAnchor.init();
preloader.init();

function hoverSocial() {
	$('.footer-social').hover(function (){
		let $wrapper = $(this);
		let $list = $($wrapper).find('.footer-social__list');
		let widthList = $($list).width();
		let $text = $($wrapper).find('.footer-social__text');

		$($wrapper).addClass('is-hover');

		$($text).css({
			'paddingRight' : widthList,
		})
	}, function (){
		let $wrapper = $(this).closest('.footer-social');
		let $text = $($wrapper).find('.footer-social__text');

		$($wrapper).removeClass('is-hover');

		$($text).css({
			'paddingRight' : '0'
		})
	})
}

function lottieAnimation() {
	$(window).scroll(function(){
		var trigger_1 = ($('.home-link--cloud').offset().top / 1.5) - $(window).scrollTop();
		var trigger_2 = ($('.home-link--safety').offset().top / 1.5) - $(window).scrollTop();
		var trigger_3 = ($('.home-link--bigdata').offset().top / 1.5) - $(window).scrollTop();
		var trigger_4 = ($('.home-link--voice').offset().top / 1.5) - $(window).scrollTop();
		var trigger_5 = ($('.home-link--iot').offset().top / 1.5) - $(window).scrollTop();

		if( trigger_1 <= 0 ) {
			$('.home-link--cloud .home-link__cloud-lottie').addClass('animStart');
		}

		if( trigger_2 <= 0 ) {
			$('.home-link--safety .home-link__safety-lottie').addClass('animStart');
		}

		if( trigger_3 <= 0 ) {
			$('.home-link--bigdata .home-link__bigdata-lottie').addClass('animStart');
		}

		if( trigger_4 <= 0 ) {
			$('.home-link--voice .home-link__voice-lottie').addClass('animStart');
		}

		if( trigger_5 <= 0 ) {
			$('.home-link--iot .home-link__iot-lottie').addClass('animStart');
		}
	});

	$('.home-link--cloud .home-link__cloud-lottie').one("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function(){
		$('.home-link--cloud .home-link__cloud-shadow').addClass('show');
	});

	$('.home-link--safety .home-link__safety-lottie').one("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function(){
		$('.home-link--safety .home-link__safety-shadow').addClass('show');
	});

	$('.home-link--bigdata .home-link__bigdata-lottie').one("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function(){
		$('.home-link--bigdata .home-link__bigdata-shadow').addClass('show');
	});

	$('.home-link--voice .home-link__voice-lottie').one("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function(){
		$('.home-link--voice .home-link__voice-shadow').addClass('show');
	});
}

function panelAnchor() {
	$(window).scroll(function(){
		var trigger_1 = ($('.panel-anchor__trigger').offset().top / 1.5) - $(window).scrollTop();

		if( trigger_1 <= 0 ) {
			$('.panel-anchor').addClass('is-active');
		} else {
			$('.panel-anchor').removeClass('is-active');
		}
	});
}

hoverSocial();

function loadPage() {
	$('html').removeClass('is-lock-scroll');
}

function videoPanel() {
	let isActive = false;
	let rightPosition = (($('.cybersecurity-interview').outerWidth() - $('.cybersecurity-interview__container').outerWidth()) / 2 ) + 'px';

	if( $(window).width() >= 1024 ) {
		rightPosition = (($('.cybersecurity-interview').outerWidth() - $('.cybersecurity-interview__container').outerWidth()) / 2 ) + 'px';
	} else {
		rightPosition = (($('.cybersecurity-interview').outerWidth() - $('.cybersecurity-interview__wrapper').outerWidth()) / 2 ) + 'px';
	}

	$('.js-panel-video').css({'right' : rightPosition})

	$(window).scroll(function(){
		var offsetFromScreenTop = ($('.js-cybersecurity-video').offset().top + $('.js-cybersecurity-video').height() ) - $(window).scrollTop();

		if( offsetFromScreenTop <= 0) {
			if( !isActive ) {
				isActive = true;
				$('.panel-video').addClass('is-active');
			}
		} else {
			if( isActive ) {
				isActive = false;
				$('.panel-video').removeClass('is-active');
			}
		}
	});
}

if (document.querySelector('.cybersecurity-interview')) {
	// $('html').scrollTop(0);
	document.querySelector('.cybersecurity-interview__picture').classList.add('is-page-loaded');

	setTimeout(() => {
		$('html').scrollTop(0);
		document.querySelector('.cybersecurity-interview__title').classList.add('is-page-loaded');
		document.querySelector('.cybersecurity-interview__figure-1').classList.add('is-page-loaded');
	}, 500);

	setTimeout(() => {
		document.querySelector('.cybersecurity-interview__container').classList.remove('is-hide');

		loadPage();
		// header.init();
		footer.init();
		console.log('init intev');
		// scroller.init();
		// slider.init();

		if( $(window).width() >= 1024 ) {

		} else {
			// panelAnchor();
		}
	}, 1500);

	setTimeout(() => {
		video.init();
		videoPanel();
	}, 2000);
}

if (document.querySelector('.cloud')) {
	document.querySelector('.cloud__picture').classList.add('is-page-loaded');

	setTimeout(() => {
		document.querySelector('.cloud__title').classList.add('is-page-loaded');
	}, 500);

	setTimeout(() => {
		document.querySelector('.cloud__container').classList.remove('is-hide');

		header.init();
		footer.init();
		// scroller.init();
		slider.init();

		if( $(window).width() >= 1024 ) {

		} else {
			panelAnchor();
		}
	}, 1500);
}

if (document.querySelector('.cybersecurity')) {
	document.querySelector('.cybersecurity__picture').classList.add('is-page-loaded');

	setTimeout(() => {
		document.querySelector('.cybersecurity__title').classList.add('is-page-loaded');
	}, 500);

	setTimeout(() => {
		document.querySelector('.cybersecurity__container').classList.remove('is-hide');

		header.init();
		footer.init();
		// scroller.init();
		slider.init();

		if( $(window).width() >= 1024 ) {

		} else {
			panelAnchor();
		}
	}, 1500);
}

if (document.querySelector('.services')) {
	document.querySelector('.services__picture').classList.add('is-page-loaded');

	setTimeout(() => {
		document.querySelector('.services__title').classList.add('is-page-loaded');
	}, 500);

	setTimeout(() => {
		document.querySelector('.services__container').classList.remove('is-hide');

		header.init();
		footer.init();
		// scroller.init();
		slider.init();

		if( $(window).width() >= 1024 ) {

		} else {
			panelAnchor();
		}
	}, 1500);
}

if (document.querySelector('.digital')) {
	document.querySelector('.digital__picture').classList.add('is-page-loaded');

	setTimeout(() => {
		document.querySelector('.digital__title').classList.add('is-page-loaded');
	}, 500);

	setTimeout(() => {
		document.querySelector('.digital__container').classList.remove('is-hide');

		header.init();
		footer.init();
		slider.init();

		if( $(window).width() >= 1024 ) {

		} else {
			panelAnchor();
		}
	}, 1500);
}

if (document.querySelector('.iot')) {
	document.querySelector('.iot__picture').classList.add('is-page-loaded');

	setTimeout(() => {
		document.querySelector('.iot__title').classList.add('is-page-loaded');
	}, 500);

	setTimeout(() => {
		document.querySelector('.iot__container').classList.remove('is-hide');

		header.init();
		footer.init();
		slider.init();

		if( $(window).width() >= 1024 ) {

		} else {
			panelAnchor();
		}
	}, 1500);
}

function showMenu(arr) {
	arr.forEach(element => {
		element.addClass('is-active');
	});
}

function hideMenu(arr) {
	arr.forEach(element => {
		element.removeClass('is-active');
	});
}

if (document.querySelector('.home')) {
	const $menu = $('.home-link__caption');
	const $menuLink = $('.home-link__button-link');
	const $menuLinkParents = $menuLink.parents('.home-link');
	const $menuBtn = $('.home-link__button');

	$menuLink.on('click', function(e) {
		let $this = $(e.currentTarget);
		let $thisMenu = $this.next('.home-link__caption');
		let $button = $this.parent();
		const $menuLinkParent = $(this).parents('.home-link');

		if ($this.hasClass('is-active')) {
			hideMenu([$this, $thisMenu, $button, $menuLinkParent]);
		} else {
			hideMenu([$menuLink, $menuBtn, $menu, $menuLinkParents]);
			showMenu([$this, $thisMenu, $button, $menuLinkParent]);
		}

		return false;
	});

	$(document).click(function (e) {
		if (!$menuLink.is(e.target) && !$menu.is(e.target) && $menu.has(e.target).length === 0) {
			hideMenu([$menuLink, $menuBtn, $menu]);
		};
	});

	document.querySelectorAll('.header')[0].style.display = 'none';

	setTimeout(() => {
		document.querySelector('.home__intro-title').classList.add('is-page-loaded');
	}, 500);

	setTimeout(() => {
		header.init();
		footer.init();

		var xhr = new XMLHttpRequest();
		xhr.onprogress = function(event) {
			alert( 'Получено с сервера ' + event.loaded + ' байт из ' + event.total );
		}
		// scroller.init();

		if( $(window).width() >= 1024 ) {
			lottieAnimation();
			lottie.init();
		}
	}, 1500);
}
